import { BloodGlucoseFormContextApiDto } from "./BloodGlucoseFormContext"
import {
  BloodGlucoseObservationApiDto,
  BloodGlucoseObservation,
  toBloodGlucoseObservation,
} from "./BloodGlucoseObservation"

export type ObservationStats = {
  medianBloodGlucoseInMilligramsPerDeciliter: number
  meanBloodGlucoseInMilligramsPerDeciliter: number
}

export type BloodGlucoseObservationsApiDto = {
  statistics: Partial<Record<BloodGlucoseFormContextApiDto, ObservationStats>>
  observations: BloodGlucoseObservationApiDto[]
}

export type BloodGlucoseObservations = {
  statistics: Partial<Record<BloodGlucoseFormContextApiDto, ObservationStats>>
  observations: BloodGlucoseObservation[]
}

export const toBloodGlucoseObservations = (
  dto: BloodGlucoseObservationsApiDto,
): BloodGlucoseObservations => ({
  statistics: dto.statistics,
  observations: dto.observations.map(toBloodGlucoseObservation),
})
